<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><span class="t5">By </span><span class="t4">SJD P</span><span class="t6">ETERSON</span></p>
<p class="p0"><span class="t5">Beyond Duty*</span></p>
<p class="p0"><span class="t5">Leon</span></p>
<p class="p0"><span class="t5">Masters &amp; Boyd</span></p>
<p class="p0"><span class="t5">Plan B*</span></p>
<p class="p0"><span class="t5">Tuck &amp; Cover</span></p>
<p class="p6"><span class="t5">W</span><span class="t7">HISPERING</span><span class="t5"> P</span><span class="t7">INES</span><span class="t5"> R</span><span class="t7">ANCH</span><span class="t5"> </span></p>
<p class="p0"><span class="t5">Lorcan’s Desire*</span></p>
<p class="p0"><span class="t5">Quinn’s Need*</span></p>
<p class="p0"><span class="t5">Ty’s Obsession*</span></p>
<p class="p0"><span class="t5">Conner’s Courage*</span></p>
<p class="p0"><span class="t5">Jess’s Journey*</span></p>
<p class="p0"><span class="t5">Riveted (short story)</span></p>
<p class="p6"><span class="t5">G</span><span class="t7">UARDS</span><span class="t5"> </span><span class="t7">OF</span><span class="t5"> F</span><span class="t7">OLSOM</span></p>
<p class="p0"><span class="t5">Pup*</span></p>
<p class="p0"><span class="t5">Tag Team*</span></p>
<p class="p0"><span class="t5">Pony*</span></p>
<p class="p7"><span class="t5">Roped*</span></p>
<p class="p8"><span class="t5">*Available in paperback</span></p>
<p class="p6"><span class="t5">Published by </span><span class="t5">D</span><span class="t7">REAMSPINNER</span><span class="t5"> P</span><span class="t7">RESS</span></p>
<p class="p0"><span class="t5">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?e88cdebc